import React, { useState } from 'react'
import { addNewUser } from '../../services/apiHelper'

const NewUserView = () => {
  const [inputValue, setInputValue] = useState('')
  const [message, setMessage] = useState()
  const handleSubmit = e => {
    e.preventDefault()
    addNewUser(inputValue).then(response => {
      if (response && response.data) {
        setMessage(<p className='c-green-700'>The user has successfully been invited!</p>)
      } else {
        setMessage(<p className='c-red-700'>Something went wrong...</p>)
      }
    })
  }

  return(
    <div className='df fxdrc aic jcc'>
      <form onSubmit={handleSubmit}>
        email:
        <input type='email' placeholde='enter email...' value={inputValue} onChange={e=> setInputValue(e.target.value)}/>
        <button type='submit'>Send Invite</button>
      </form>
      {message}
    </div>
  )
}

export default NewUserView